define('bindingHandlers/advancedUserSelect',[
    'lib/knockout',
    'lib/lodash4',
    'lib/bluebird',
    'util/externalInclude',
    'services/toastService',
    'services/userService',
    'services/authService',
    'models/Location',
    'models/Role'
], function (
    ko,
    _,
    Promise,
    include,
    toastService,
    userService,
    authService,
    Location,
    Role
) {
    'use strict';

    var pageCount = ko.observable(1);

    var pageNumber = ko.observable(1);

    var pageSize = ko.observable(25);

    var useAutocomplete = ko.observable(false);

    var userList = ko.observableArray();

    var comboList = ko.observableArray();

    var originalSelectedUsers = [];

    var selectedRows = ko.observableArray();

    var isSelectingSearchType = ko.observable(false);

    var selectedSearchType = ko.observable();

    var searchTerm = ko.observable('');

    var isLoadingRows = ko.observable(false);

    var allRoles = ko.observableArray();

    var getAgents;
    var getUsersByIds;
    var searchUsers;
    var searchGroups;
    var getRoles;
    var getLocations;
    var getUsers;
    var getLocationIds;
    var getDirectReports;

    var updateTable = function(newUserList, pageInfo) {
        userList(newUserList);
        isLoadingRows(false);

        pageCount(pageInfo.pageCount);
        pageNumber(pageInfo.pageNumber);
        pageSize(pageInfo.pageSize);
    };

    var userSearch = function() {
        var params = {
            name: searchTerm(),
            pageNumber: pageNumber(),
            pageSize: pageSize()
        };

        return getAgents(params).then(function(response) {
            updateTable(response.entities, response);
        }).catch(handleSearchFailure);
    };

    var selectedUserSearch = function() {
        if (searchTerm() === '') {
            updateTable(selectedRows(), { pageNumber: 1, pageSize: 25, pageCount: 1 });
        }

        var searchResults = selectedRows().filter(function(row) {
            var words = _.words(row.name().toLowerCase());
            var forwardCompare = _.includes(words.join(' '), searchTerm().toLowerCase());
            var reverseCompare = _.includes(words.reverse().join(' '), searchTerm().toLowerCase());
            return row.name() === searchTerm() || forwardCompare || reverseCompare;
        });

        updateTable(searchResults, { pageNumber: 1, pageSize: 25, pageCount: 1 });
    };

    var byGroupSearch = function(searchText) {
        var params = {
           pageSize: 5,
           pageNumber: 1,
           query: [
            {
              type: "EXACT",
              fields: [
                "state"
              ],
              value: "active"
            }
          ]
        };

        if (searchText) {
            params.query.push({
              type: "CONTAINS",
              fields: [
                "name"
              ],
              value: searchText
            });
        }

        return searchGroups(params).catch(handleSearchFailure);
    };

    var byRoleSearch = function(searchText) {
        // Only search 1 time for roles and save them.
        var p;
        if (allRoles() && allRoles().length) {
            p = Promise.resolve(allRoles());
        } else {
            p = getRoles({ pageSize: 1000 });
        }
        return p.then(function(results) {
            var roles = [];
            allRoles(results);
            _.forEach(results, function(role) {
                if (roles.length < 5 && role.name.substr(0, searchText.length) === searchText) {
                    roles.push(new Role(role));
                }
            });

            return roles;
        }).catch(handleSearchFailure);
    };

    var reportsToSearch = function(searchText) {
        var params = {
            pageSize: 5,
            pageNumber: 1,
            query: [
                {
                    type: 'EXACT',
                    fields: [
                        'state'
                    ],
                    value: 'active'
                }
            ],
            sortOrder: 'ASC',
            sortBy: 'name'
        };

        if (searchText) {
            params.query.push({
                type: 'CONTAINS',
                fields: [
                    'name',
                    'email',
                    'title',
                    'department'
                ],
                value: searchText
            });
        }

        return searchUsers(params).then(function(response) {
            return response.results;
        }).catch(handleSearchFailure);
    };

    var locationSearch = function(searchText) {
        return getLocations({ pageSize: 9999 }).then(function(results) {
            var locations = [];
            _.forEach(results, function(location) {
                if (locations.length < 5 && location.name.substr(0, searchText.length) === searchText) {
                    locations.push(new Location(location));
                }
            });

            return locations;
        }).catch(handleSearchFailure);
    };

    var byGroupTagSearch = function() {
        var tags = comboList();
        if (tags.length > 0) {
            isLoadingRows(true);
            var groupIds = tags.map(function(tag) {
                return tag.id;
            });

            var params = {
                pageNumber: pageNumber(),
                pageSize: pageSize(),
                types: [
                    'users'
                ],
                query: [
                    {
                        type: 'EXACT',
                        fields: [
                            'state'
                        ],
                        value: 'active'
                    },
                    {
                        type: 'EXACT',
                        fields: [
                            'groups.official.guid',
                            'groups.social.guid'
                        ],
                        values: groupIds
                    }
                ]
            };

            return searchUsers(params)
                .then(function (response) {
                    updateTable(response.results, response);
                }).catch(handleSearchFailure);
        } else {
            updateTable([], { pageNumber: 1, pageSize: 25, pageCount: 1 });
        }
    };

    var byRoleTagSearch = function() {
        isLoadingRows(true);

        var promises = [];
        var userPromises = [];
        var users = [];
        var maxPageCount = 1;

        // For each selected role
        // Grab the top 25 users granted access
        // Set page count to whatever is needed to get through each role
        // Do user search for name and for division-permitted check

        if (comboList().length) {
            comboList().forEach(function (role) {
                promises.push(authService.getRoleUsers(role.id, { pageNumber: pageNumber(), pageSize: 25 }).then(function (response) {
                    maxPageCount = Math.max(maxPageCount, response.pageCount);
                    if (response && response.entities && response.entities.length) {
                        userPromises.push(getUsersByIds(response.entities.map(function (user) {
                            return user.id;
                        })).then(function (response) {
                            users = users.concat(ko.unwrap(response));
                        }));
                    }
                }));
            });
        } else {
            updateTable([], { pageNumber: 1, pageSize: 25, pageCount: 1 });
        }

        Promise.all(promises)
            .then(function () {
                return Promise.all(userPromises);
            })
        .finally(function () {
            users = _.sortBy(_.uniqBy(users, "id"), "name"); 
            updateTable(users, { pageNumber: pageNumber(), pageSize: 25, pageCount: maxPageCount });
        }).catch(handleSearchFailure);
    };

    var reportsToTagSearch = function() {
        userList.removeAll();
        var tags = comboList();
        if (tags.length > 0) {

            pageCount(1);
            pageNumber(1);
            pageSize(25);

            isLoadingRows(true);
            _.forEach(tags, function(tag) {
                getDirectReports(tag.id, {}).then(function(response) {
                    isLoadingRows(false);

                    userList.push.apply(userList, response);
                }).catch(handleSearchFailure);
            });
        } else {
            updateTable([], { pageNumber: 1, pageSize: 25, pageCount: 1 });
        }
    };

    var locationTagSearch = function() {
        var tags = comboList();
        if (tags.length > 0) {
            var locationIds = tags.map(function(tag) {
                return tag.id;
            });

            return getLocationIds(locationIds).then(function(locationGuids) {
                var params = {
                    pageNumber: pageNumber(),
                    pageSize: pageSize(),
                    types: [
                        'users'
                    ],
                    query: [
                        {
                            type: 'EXACT',
                            fields: [
                                'state'
                            ],
                            value: 'active'
                        },
                        {
                            type: 'EXACT',
                            fields: [
                                'location.location.value.locationId'
                            ],
                            values: locationGuids
                        }
                    ]
                };

                return searchUsers(params)
                    .then(function (response) {
                        updateTable(response.results, response);
                    });
            }).catch(handleSearchFailure);
        } else {
            updateTable([], { pageNumber: 1, pageSize: 25, pageCount: 1 });
        }
    };

    var SEARCH_TYPES = {
        SELECTED: { key: 'selected', displayValue: 'advancedUserSelect.selected', hidden: true, searchAction: selectedUserSearch, useAutocomplete: false },
        FULL_SEARCH: { key: 'fullsearch', displayValue: 'advancedUserSelect.search', hidden: false, searchAction: userSearch, useAutocomplete: false },
        BY_GROUP: { key: 'bygroup', displayValue: 'advancedUserSelect.byGroup', hidden: false, searchAction: byGroupSearch, tagSearchAction: byGroupTagSearch, useAutocomplete: true  },
        BY_ROLE: { key: 'byrole', displayValue: 'advancedUserSelect.byRole', hidden: false, searchAction: byRoleSearch, tagSearchAction: byRoleTagSearch, useAutocomplete: true  },
        REPORTS_TO: { key: 'reportsto', displayValue: 'advancedUserSelect.reportsTo', hidden: false, searchAction: reportsToSearch, tagSearchAction: reportsToTagSearch, useAutocomplete: true  },
        LOCATION: { key: 'location', displayValue: 'advancedUserSelect.location', hidden: false, searchAction: locationSearch, tagSearchAction: locationTagSearch, useAutocomplete: true  }
    };

    var SEARCH_TYPES_LIST = [];
    for (var type in SEARCH_TYPES) {
        SEARCH_TYPES_LIST.push(SEARCH_TYPES[type]);
    }

    var showSelectedUsers = function() {
        updateTable(selectedRows(), { pageNumber: 1, pageSize: 25, pageCount: 1 });
        selectedSearchType(SEARCH_TYPES.SELECTED);
        useAutocomplete(selectedSearchType().useAutocomplete);
        searchTerm('');
    };

    var selectSearchType = function(searchType) {
        updateTable([], { pageNumber: 1, pageSize: 25, pageCount: 1 });
        comboList.removeAll();
        isSelectingSearchType(false);
        selectedSearchType(searchType);
        useAutocomplete(selectedSearchType().useAutocomplete);
    };

    var refreshGrid = _.debounce(function() {
        isLoadingRows(true);
        var searchAction = selectedSearchType().useAutocomplete ? selectedSearchType().tagSearchAction : selectedSearchType().searchAction;
        searchAction();
    }, 500);

    var handleSearchFailure = function() {
        isLoadingRows(false);
        toastService.notifyCriticalAlert('config.error.500');
    };

    var search = function(searchText) {
        return selectedSearchType().searchAction(searchText);
    };

    var resetTable = function() {
        selectedSearchType(SEARCH_TYPES.SELECTED);
        searchTerm('');
        updateTable(selectedRows(), { pageNumber: 1, pageSize: 25, pageCount: 1 });
        comboList.removeAll();
    };

    searchTerm.subscribe(_.debounce(function() {
        isLoadingRows(true);
        selectedSearchType().searchAction();
    }, 500));

    comboList.subscribe(_.debounce(function() {
        if (selectedSearchType().tagSearchAction) {
            selectedSearchType().tagSearchAction();
        }
    }, 200));

    ko.bindingHandlers.advancedUserSelect = {
        init: function (element, valueAccessor) {
            var params = ko.unwrap(valueAccessor());

            selectedSearchType(SEARCH_TYPES.SELECTED);
            selectedSearchType().searchAction();

            getAgents = params.getAgents;
            getUsersByIds = params.getUsersByIds;
            searchUsers = params.searchUsers;
            searchGroups = params.searchGroups;
            getRoles = params.getRoles;
            getLocations = params.getLocations;
            getUsers = params.getUsers;
            getLocationIds = params.getLocationIds;
            getDirectReports = params.getDirectReports;

            var closeAdvanced = function() {
                params.showAdvanced(false);
                selectedRows(originalSelectedUsers.slice(0));
                resetTable();
            };

            var saveAndClose = function() {
                params.saveAdvanced(selectedRows());
                resetTable();
            };

            var assignedCount = ko.computed(function() {
                return selectedRows().length;
            });

            var addedCount = ko.computed(function() {
                return _.differenceBy(selectedRows(), originalSelectedUsers, 'id').length;
            });

            var removedCount = ko.computed(function() {
                return _.differenceBy(originalSelectedUsers, selectedRows(), 'id').length;
            });

            var hasUnsavedChanges = ko.computed(function() {
                return removedCount() + addedCount() !== 0;
            });

            var userSelect = {
                showAdvanced: params.showAdvanced,
                isSelectingSearchType: isSelectingSearchType,
                selectedSearchType: selectedSearchType,
                comboList: comboList,
                search: search,
                SEARCH_TYPES_LIST: SEARCH_TYPES_LIST,
                selectSearchType: selectSearchType,
                saveAndClose: saveAndClose,
                showSelectedUsers: showSelectedUsers,
                closeAdvanced: closeAdvanced,
                pageNumber: pageNumber,
                pageSize: pageSize,
                pageCount: pageCount,
                selectedRows: selectedRows,
                refreshGrid: refreshGrid,
                searchTerm: searchTerm,
                userList: userList,
                assignedCount: assignedCount,
                addedCount: addedCount,
                removedCount: removedCount,
                hasUnsavedChanges: hasUnsavedChanges,
                isLoadingRows: isLoadingRows
            };

            include.loadTemplate('templates/widgets/advancedUserSelect').then(function() {
                ko.renderTemplate('templates/widgets/advancedUserSelect', userSelect, { }, element);
            });
        },
        update: function(element, valueAccessor){
            var params = ko.unwrap(valueAccessor());
            // clone arrays
            originalSelectedUsers = params.selected.slice(0);
            selectedRows(params.selected.slice(0));
            if (!params.showAdvanced()) {
                updateTable(selectedRows(), { pageNumber: 1, pageSize: 25, pageCount: 1 });
            }
        }
    };
});

